import React from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from '../../utils';

/* replace-start */
import './index.less';
/* replace-end */
class Feature11 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.children;
      return itemLists.map((key, i) => {
        const { title, img, imgIcon, content, ...other } = key;
        return (
          <div {...other} key={i}>
            <div className="box">
              <div {...img}>
                <img src={img.children} alt="" />
              </div>
              <div className="row">
                <div {...imgIcon}>
                  <img src={imgIcon.children} alt="" />
                </div>
                <div {...title}>
                  <span dangerouslySetInnerHTML={{ __html: title.children }} />
                </div>
              </div>
              <div {...content}>
                <span dangerouslySetInnerHTML={{ __html: content.children }} />
              </div>
            </div>

          </div>
        );
      }
      );
    }

    return (
      <OverPack
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.page}>
          <TweenOne
            animation={{
              y: 0,
              duration: 300,
            }}
            style={{ transform: 'translateY(-180px)' }}
            key="title"
            {...dataSource.title}
            data-edit="text"
          >
            {
              dataSource.title.children.map(getChildrenToRender)
            }
          </TweenOne>
          <QueueAnim
            delay={300}
            duration={1000}
            type="scaleX"
            {...dataSource.content}
          >
            {getItem()}
          </QueueAnim>
        </div>
      </OverPack>
    );
  }
}
export default Feature11;
